import {
  HorseShare,
  HorseShareActionResponseTypeEnum,
} from '@sleipai/sleip-models';
import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import {
  horsesShareFeatureKey,
  selectAllHorseSharesAdapter,
  State,
} from '../reducers/horses-share.reducer';

export const selectHorsesShareState: MemoizedSelector<object, State> =
  createFeatureSelector<State>(horsesShareFeatureKey);

export const isLoading = (state: State): boolean => state.loading;
export const isLoaded = (state: State): boolean => state.loaded;
export const horseShareSaved = (state: State): boolean => state.horseShareSaved;
export const horseShareError = (state: State): string | any | null =>
  state.error;
export const horseShareActionResponseType = (
  state: State
): HorseShareActionResponseTypeEnum | null =>
  state.horseShareActionResponseType;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectHorsesShareState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectHorsesShareState,
  isLoaded
);

export const selectHorsesShareSaved: MemoizedSelector<object, boolean> =
  createSelector(selectHorsesShareState, horseShareSaved);

export const selectHorsesShareError: MemoizedSelector<
  object,
  string | any | null
> = createSelector(selectHorsesShareState, horseShareError);

export const selectHorseShareActionResponseType: MemoizedSelector<
  object,
  HorseShareActionResponseTypeEnum | null
> = createSelector(selectHorsesShareState, horseShareActionResponseType);

export const selectAllHorsesShare: (state: object) => HorseShare[] =
  createSelector(selectHorsesShareState, selectAllHorseSharesAdapter);

export const selectHorsesShareItem = (
  groupId: string,
  horseId: string,
) =>
  createSelector(selectAllHorsesShare, (horsesShares: HorseShare[]) => {
    if (horsesShares && horsesShares.length !== 0) {
      return (
        horsesShares.find(
          (horsesShare) =>
            horsesShare.groupId === groupId && horsesShare.horseId === horseId
        ) ?? null
      );
    } else {
      return null;
    }
  });
